const RECEIVE_SEARCH_DATA_FOR_MAIN = 'src/omniSearchService/RECEIVE_SEARCH_DATA_FOR_MAIN' as const;
const RECEIVE_SEARCH_DATA_FOR_COMPARE = 'src/omniSearchService/RECEIVE_SEARCH_DATA_FOR_COMPARE' as const;
const START_FETCH = 'src/omniSearchService/START_FETCH' as const;
const END_FETCH = 'src/omniSearchService/END_FETCH' as const;

export default { RECEIVE_SEARCH_DATA_FOR_MAIN, RECEIVE_SEARCH_DATA_FOR_COMPARE, START_FETCH, END_FETCH };
